import { useCardStore } from '../../card/CardProvider';
export const useAssociationsFromObjectType = () => {
  const cardStore = useCardStore();
  return cardStore.associationsPerType;
};